import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/slt-mobitel-logo.png";
import backgroundImage from "../assets/background.jpg";
import "../styles/style.css";
import Footer from "./Footer";
import ChatbotIcon from "../assets/chatbot.png";

const Readmore = () => {
  const navigate = useNavigate();
  const [chatbotVisible, setChatbotVisible] = useState(false);
  const [chatbotLoaded, setChatbotLoaded] = useState(false);

  useEffect(() => {
    const loadWebChatLibrary = () => {
      return new Promise((resolve, reject) => {
        if (window.WebChat) {
          resolve(window.WebChat);
        } else {
          const script = document.createElement("script");
          script.src =
            "https://cdn.botframework.com/botframework-webchat/latest/webchat.js";
          script.onload = () => resolve(window.WebChat);
          script.onerror = () =>
            reject(new Error("WebChat library failed to load"));
          document.body.appendChild(script);
        }
      });
    };

    const loadChatbot = async () => {
      try {
        // Fetch token from Flask server
        const WebChat = await loadWebChatLibrary();
        const response = await fetch("http://127.0.0.1:5002/get_token", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch token from server");
        }

        const data = await response.json();
        const token = data.token;

        if (!token) {
          throw new Error("No token received from server");
        }

        const directLine = WebChat.createDirectLine({ token });

        WebChat.renderWebChat(
          {
            directLine: directLine,
            userID: "user-001",
            username: "User",
            locale: "en-US",
            styleOptions: {
              botAvatarInitials: "AI",
              userAvatarInitials: "U",
              bubbleBackground: "#F1F1F1",
              bubbleFromUserBackground: "#0078D7",
              bubbleFromUserTextColor: "white",
              rootHeight: "100%",
              rootWidth: "100%",
            },
          },
          document.getElementById("webchat")
        );

        console.log("Chatbot loaded!");
      } catch (error) {
        console.error("Error loading chatbot:", error);
      }
    };

    if (chatbotVisible && !chatbotLoaded) {
      loadChatbot();
      setChatbotLoaded(true);
    }
  }, [chatbotVisible, chatbotLoaded]);

  const handleCloseChatbot = () => {
    setChatbotVisible(false);
    setChatbotLoaded(false);
  };

  return (
    <div
      style={{
        minHeight: "94vh",
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
        fontFamily: "'Poppins', sans-serif",
        textAlign: "center",
      }}
    >
      {/* Responsive CSS inside <style> */}
      <style>{`
         /* Mobile (≤767px) */
  @media screen and (max-width: 767px) {
    .container {
      font-size: 14px;
      padding: 10px;
    }
    .header {
      font-size: 24px;
    }
    .chatbot-window {
      width: 95%;
      height: 65vh;
      left: 50%;
      bottom: 80px;
      transform: translateX(-50%);
      border-radius: 12px;
    }
    .floating-ball {
    bottom: 80px;  /* lifted above footer */
    right: 15px;
    width: 55px;
    height: 55px;
  }
  .floating-ball img {
    width: 40px;
    height: 40px;
  }
  }

  /* Very Small Devices (≤480px) */
  @media screen and (max-width: 480px) {
    .header {
      font-size: 20px;
    }
    .chatbot-window {
      width: 100%;
      height: 75vh;
      left: 0;
      transform: none;
      border-radius: 0;
      bottom: 0;
    }
    .floating-ball {
    bottom: 70px; /* more space for very small screens */
    right: 10px;
    width: 50px;
    height: 50px;
  }
  .floating-ball img {
    width: 35px;
    height: 35px;
  }
    .logo2 {
      width: 100px !important;
    }
  }

  /* Tablets (768px - 1024px) */
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .chatbot-window {
      width: 70%;
      height: 70vh;
      left: 15%;
      bottom: 90px;
    }
    .floating-ball {
      width: 65px;
      height: 65px;
    }
    .floating-ball img {
      width: 50px;
      height: 50px;
    }
  }
      `}</style>
      <img
        src={Logo}
        alt="Logo"
        className="logo2"
        style={{ width: "150px", height: "auto" }}
        onClick={() => {
          navigate("/");
        }}
      />

      <div className="readmore-header">How the Chatbot Can Assist You?</div>

      <div className="readmore-container">
        Our intelligent support chatbot is designed to assist you throughout
        your internship or training journey by providing timely, accurate, and
        personalized guidance. Here's how it can help:
        <br />
        <br />
        🔁<b>Internship & Training Guidance</b>
        <br />
        <br />
        💡Get step-by-step assistance on how to request and obtain your official
        internship or training completion certificate.
        <br />
        💡Receive guidance on how to transfer your current internship or
        training assignment to another branch or department.
        <br />
        💡Learn how to apply for an extension if you need more time to complete
        your internship or training.
        <br />
        💡Understand the schedule, purpose, and expectations of induction
        sessions for new interns or trainees.
        <br />
        💡Find out about potential pathways to secure a permanent job after
        successful completion of your internship.
        <br />
        <br />
        🔁<b>Personalized Assistance</b>
        <br />
        <br />
        💡For any specific questions or unique situations, simply ask! The
        chatbot is equipped to deliver customized guidance based on your input
        and institutional policies.
        <br />
        <br />
        🔁<b>Available 24/7 </b>
        <br />
        <br />
        💡Our chatbot is always ready to support you, ensuring you have the help
        you need when you need it most.
      </div>

      {/* Background overlay */}
      {chatbotVisible && (
        <div
          onClick={handleCloseChatbot}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 999,
            marginBottom: "25px",
          }}
        />
      )}

      {/* Floating Ball (Chat Icon) */}
      <div
        className="floating-ball"
        onClick={() => setChatbotVisible(true)}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
          e.currentTarget.style.boxShadow =
            "0px 0px 15px 5px rgba(74, 222, 241, 0.97)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <img
          src={ChatbotIcon}
          alt="Chatbot Icon"
          style={{
            width: "45px",
            height: "45px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Chatbot Window */}
      {chatbotVisible && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            AI Assistant
            <span className="chatbot-close" onClick={handleCloseChatbot}>
              ×
            </span>
          </div>
          <div id="webchat" className="chatbot-content"></div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Readmore;
